import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { IFormQuestion } from '@fi-shared/fi-form-shared/fi-form-shared';
import { takeUntil } from 'rxjs/operators';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';

@Directive()
export class FiFormQuestionBase extends FiComponentsContainer implements OnInit, OnDestroy {
    @Input() question: IFormQuestion;
    @Output() questionChange = new EventEmitter<IFormQuestion>();
    @Input() isFormTranslated: boolean;
    @Input() questionIndex: number;
    @Input() defaultLanguageId: number;
    @Input() selectedLanguageId: number;
    @Input() focusedQuestionNameUid: number;
    @Output() onDragDisableChange = new EventEmitter<boolean>();
    @Output() toggleMandatory = new EventEmitter<IFormQuestion>();
    @Output() toggleDisabled = new EventEmitter<IFormQuestion>();
    @Output() deleteQuestion = new EventEmitter<IFormQuestion>();

    isActive$ = new BehaviorSubject<boolean>(false);

    constructor(
        private fiBrowserEventsService: FiBrowserEventsService,
        public elementRef: ElementRef,
        protected fiFormHelperService: FiFormHelperService,
    ) {
        super();
    }

    ngOnInit() {
        this.subscribeOnDocumentClick();
    }

    isQuestionNameFocused(): boolean {
        return this.question.uid === this.focusedQuestionNameUid;
    }

    isQuestionNameContentLangIdSelected(contentLangId: number): boolean {
        return contentLangId === this.selectedLanguageId;
    }

    private subscribeOnDocumentClick() {
        this.fiBrowserEventsService
            .getDocumentEventSubject$('click')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((e: MouseEvent) => this.onClick(e));
    }

    private onClick(event: MouseEvent) {
        this.isActive$.next(this.isClickInside(event));
    }

    private isClickInside(event: MouseEvent) {
        return this.elementRef.nativeElement.contains(event.target);
    }

    onQuestionChanged() {
        this.questionChange.emit(this.question);
    }

    disableElementDrag(isDragDisable: boolean): void {
        this.onDragDisableChange.emit(isDragDisable);
    }

    isQuestionNameRequired(questionName: IContentLanguageLabelModel): boolean {
        return this.fiFormHelperService.isQuestionNameRequired(questionName, this.isFormTranslated);
    }

    toggleQuestionDisabledStatus() {
        this.toggleDisabled.emit(this.question);
    }

    toggleQuestionMandatoryStatus() {
        this.toggleMandatory.emit(this.question);
    }

    onDeleteQuestion() {
        this.deleteQuestion.emit(this.question);
    }

    protected ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
